// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"_0-z","subtitle":"a1-z","wrapper":"b1-z","leftArrow":"c1-z","rightArrow":"d1-z"};